(function () {
  function slideHeight(root) {
    var viewport = root.querySelector('.pv-ordinary-promo-bar__viewport');
    return viewport ? viewport.offsetHeight : 37;
  }

  function initPromoBar(root) {
    if (!root) return;

    var track = root.querySelector('[data-pv-promo-track]');
    if (!track) return;

    var slides = Array.from(track.children);
    if (slides.length < 2) {
      track.style.transform = 'none';
      return;
    }

    if (root._pvPromoCleanup) root._pvPromoCleanup();

    var index = 0;
    var intervalMs = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var timer = null;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      var offset = index * slideHeight(root);
      track.style.transform = 'translate3d(0, -' + offset + 'px, 0)';
      slides.forEach(function (slide, n) {
        slide.setAttribute('aria-hidden', n === index ? 'false' : 'true');
      });
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      timer = window.setInterval(next, intervalMs);
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    var onPrev = function () {
      prev();
      startAutoplay();
    };
    var onNext = function () {
      next();
      startAutoplay();
    };

    root.querySelector('[data-pv-promo-prev]')?.addEventListener('click', onPrev);
    root.querySelector('[data-pv-promo-next]')?.addEventListener('click', onNext);
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    var onResize = function () {
      goTo(index);
    };
    window.addEventListener('resize', onResize);

    root._pvPromoCleanup = function () {
      stopAutoplay();
      window.removeEventListener('resize', onResize);
      root.querySelector('[data-pv-promo-prev]')?.removeEventListener('click', onPrev);
      root.querySelector('[data-pv-promo-next]')?.removeEventListener('click', onNext);
      delete root.dataset.pvPromoInit;
    };

    root.dataset.pvPromoInit = 'true';
    goTo(0);
    startAutoplay();
  }

  function boot() {
    document.querySelectorAll('[data-pv-ordinary-promo]').forEach(initPromoBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pv-ordinary-promo]');
    if (root) initPromoBar(root);
  });
})();
